export enum ListaEnum {
  NACIONALIDADE = 2,
  TIPOTELEFONE = 4,
  ESTADOCIVIL = 9,
  TIPORESIDENCIA = 10,
  ESCOLARIDADE = 13,
  TIPODEFICIENCIAFISICA =14,
  CORDAPELE = 56,
  STATUSCANDIDATO = 355,
  GRUPOSANGUINEO = 405,
  FATORRH = 406,
  CNHCATEGORIA = 383,
  RESERVISTACATEGORIA = 11,
  RESERVISTAFORCA = 12  
}


// WEBPACK FOOTER //
// ./src/app/models/enum/lista.ts